const Arrow = ({ className }: { className?: string }) => (
    <svg
        width="138"
        height="138"
        className={className}
        viewBox="0 0 138 138"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M124 30.0001L75.7644 79.2356L50.7069 54.1782L15 88.8851M124 30.0001L86.4138 30M124 30.0001V67.5862"
            stroke="#F4C4B5"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default Arrow;
